import http from "./http";
export const baseUrl = "/v1/api/app";

const { get, post } = http;
const getSuperDeviceListApi = (params: any) => post(`${baseUrl}/superDevice/model/page`, params); // 查询我超级设备模板列表
const getSuperDeviceNoPage = (params: any) => post(`${baseUrl}/superDevice/model/list`, params); // 查询我超级设备模板列表不带分页
const addSuperDeviceApi = (params: any) => post(`${baseUrl}/superDevice/model/create`, params); // 超级设备模板创建
const checkSuperDeviceNameApi = (params: any) => post(`${baseUrl}/superDevice/model/name/exist`, params); // 检查名称是否存在
const getSuperDeviceDetailApi = (params: any) => post(`${baseUrl}/superDevice/model/detail`, params); // 超级设备模板详情
const getSuperDeviceDeleteApi = (params: any) => post(`${baseUrl}/superDevice/model/delete`, params); // 超级设备模板删除
const getSuperDeviceSaveApi = (params: any) => post(`${baseUrl}/superDevice/model/save`, params); // 超级设备模板保存
// const defaultPrivate = (params: any) => get(`${baseUrl2}/file/default/private/url`, { params }); //默认私有文件下载地址
export default {
    getSuperDeviceListApi,
    getSuperDeviceNoPage,
    addSuperDeviceApi,
    checkSuperDeviceNameApi,
    getSuperDeviceDetailApi,
    getSuperDeviceDeleteApi,
    getSuperDeviceSaveApi
};
